// Требования к паролю дублируют проверку бэка (AccountPasswordUtils) — форма
// не даёт отправить заведомо отказной запрос.
export const MIN_PASSWORD_LENGTH = 4;

export const CONFIRMATION_CODE_LENGTH = 4;
